module.exports = __webpack_public_path__ + "static/media/29DUNON9.5d5b7de3.jpg";